import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-footer-top',
  templateUrl: './footer-top.component.html',
  styleUrls: ['./footer-top.component.css']
})
export class FooterTopComponent implements OnInit {

  email = new FormControl('', [Validators.required])

  constructor( private _neproseService: NeproseService, private notification: MatSnackBar ) { }

  ngOnInit(): void {

  }

  subscribe(){
    this._neproseService.addSubscription(this.email.value).subscribe(data => {
      if(data.status){
        this.email.reset()
        this.email.setErrors(null)
        this.openNotification('You have subscribed to Nepal Property Services.')
      }
    }, error => {
      if(error.error.message)
        this.openNotification(error.error.message)
    })
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
